/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/camelcase */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { HotKeys } from 'react-hotkeys';
import zenscroll from 'zenscroll';
import {
  getFormSyncErrors,
  getFormValues,
  arrayRemove,
  reduxForm,
} from 'redux-form';

import _get from 'lodash/get';
import _size from 'lodash/size';
import _isEqual from 'lodash/isEqual';
import _isEmpty from 'lodash/isEmpty';

import Form from 'components/Form';
import InspectFooter from 'components/InspectFooter';
import InspectLoader from 'components/InspectLoader';
import InspectButton from 'components/InspectButton';

import EntityInspect from 'scenes/Entities/components/EntityInspect';
import CreateNewEntityModal from 'scenes/Entities/components/CreateNewEntityModal';
import UnsavedChangesModal from 'components/UnsavedChangesModal';

import * as entitiesActions from 'store/services/entities/actions';
import * as entitiesSelectors from 'store/services/entities/selectors';
import * as entitiesFeaturesActions from 'store/services/entitiesFeatures/actions';
import * as ruleEntitiesSelectors from 'store/services/ruleEntities/selectors';
import * as entitiesFeaturesSelectors from 'store/services/entitiesFeatures/selectors';
import * as ruleGroupsActions from 'store/services/ruleGroups/actions';
import * as ruleGroupsSelectors from 'store/services/ruleGroups/selectors';
import * as rulesActions from 'store/services/rules/actions';
import * as rulesSelectors from 'store/services/rules/selectors';
import * as featuresSelectors from 'store/services/features/selectors';
import * as contextActions from 'store/services/contexts/actions';
import * as contextSelectors from 'store/services/contexts/selectors';
import * as testSetsSelectors from 'store/services/testSets/selectors';
import * as testSetEntriesSelectors from 'store/services/testSetEntries/selectors';

import BLOCKS from 'constants/defaultContextBlocks';
import { ruleType, contextType, entityType, featuresType } from 'types';

import { constructFeaturesToSave } from 'store/utils/entities';
import COMBOS from 'constants/keyboardShortcutsCombos';
import FORM_NAMES from 'constants/formNames';

import Headers from '../RulesInspectTabs';

import GeneralTab from './components/General';
import ConditionsTab from './components/Conditions';
import MatchingPatternTab from './components/MatchingPattern';
import ActionsTab from './components/Actions';
import ContextTab from './components/Context';
import ContextCreate from './components/ContextCreate';

import {
  validate,
  createRequestPayload,
  createReduxFormInitialValues,
} from './utils';

import { ACTION_TYPE, FEATURE_VALUE_TYPE, TABS } from './constants';

import './style.scss';

const HOTKEYS_MAP = {
  save: COMBOS.saveNew,
  leave: COMBOS.closeInspect,
};

export class Inspect extends Component {
  keyHandlers = {
    save: this.handleSave,
    leave: this.handleClose,
  };

  static propTypes = {
    asyncValidating: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
      .isRequired,
    change: PropTypes.func.isRequired,
    destroy: PropTypes.func.isRequired,
    dirty: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,

    executeAnnotator: PropTypes.func.isRequired,
    groupId: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,

    hasMandatoryMPE: PropTypes.bool.isRequired,

    hasSelectedTestSet: PropTypes.bool.isRequired,

    history: PropTypes.shape({
      replace: PropTypes.func.isRequired,
    }).isRequired,

    initialize: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,

    invalidWithUnregistered: PropTypes.bool.isRequired,

    isLoading: PropTypes.bool.isRequired,
    match: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }).isRequired,

    partialExport: PropTypes.func.isRequired,
    ruleId: PropTypes.string.isRequired,
    testSetEntriesCount: PropTypes.number.isRequired,
    untouch: PropTypes.func.isRequired,
    onAddContext: PropTypes.func.isRequired,
    onAddEntity: PropTypes.func.isRequired,

    onCheckEntityName: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onDeleteRule: PropTypes.func.isRequired,
    onDeselect: PropTypes.func.isRequired,

    onGetAllContexts: PropTypes.func.isRequired,
    onGetAllEntities: PropTypes.func.isRequired,
    onGetAllRuleGroups: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    onUpdateEntity: PropTypes.func.isRequired,
    onUpdateEntityFeatures: PropTypes.func.isRequired,
    onUpdateRule: PropTypes.func.isRequired,

    context: contextType,
    contexts: PropTypes.arrayOf(contextType),
    contextsIsLoading: PropTypes.bool,
    entities: PropTypes.arrayOf(entityType),
    entitiesIsLoading: PropTypes.bool,
    entity: entityType,
    entityFeatures: PropTypes.arrayOf(featuresType),
    entityFormValues: entityType,
    features: PropTypes.arrayOf(featuresType),
    formValues: ruleType,
    initialValues: ruleType,
    matchingPatterns: PropTypes.arrayOf(entityType),
    matchingPatternsWithoutAny: PropTypes.arrayOf(entityType),
    matchingPatternsWithoutAnyAndW: PropTypes.arrayOf(entityType),
    orderList: PropTypes.arrayOf(
      PropTypes.shape({
        index: PropTypes.number,
        order: PropTypes.string,
      }),
    ),
    rule: PropTypes.shape({
      actions: PropTypes.arrayOf(PropTypes.object),
      archived: PropTypes.bool,
      conditions: PropTypes.arrayOf(PropTypes.object),
      id: PropTypes.string,
      name: PropTypes.string,
      rule_group: PropTypes.string,
    }),
    ruleGroups: PropTypes.arrayOf(ruleType),
    ruleGroupsIsLoading: PropTypes.bool,

    selectedRule: PropTypes.bool,
    showUnsavedChangesModal: PropTypes.bool,
    onChangeRule: PropTypes.func,
    onCloseUnsavedChangesModal: PropTypes.func,
  };

  state = {
    tab: TABS[0].tabIndex,
    isCreateEntityModalOpen: false,
    isEntityInspectInjected: false,
    isContextCreateInjected: false,
    isUnsavedChangesModalOpen: false,
    inspectInjectedFor: null,
  };

  componentDidMount = () => {
    const { ruleId, groupId } = this.props;

    if (!this.props.isLoading) {
      this.props.initialize(this.props.initialValues);
    }

    if (ruleId && groupId) {
      this.props.onSelect(ruleId, groupId);
    }
  };

  componentWillReceiveProps = ({ ruleId, groupId, initialValues }) => {
    if (!_isEqual(this.props.initialValues, initialValues)) {
      this.props.initialize(initialValues);
    }

    if (this.props.ruleId !== ruleId || this.props.groupId !== groupId) {
      this.props.onSelect(ruleId, groupId);
    }
  };

  componentWillUnmount = () => {
    this.props.destroy();
    this.props.onDeselect();
  };

  getTabs = () => {
    const { formValues } = this.props;
    if (!formValues) {
      return TABS;
    }

    return TABS.map(tab => {
      let hasWarning = false;

      if (tab.tabIndex === 2 && !_size(formValues.entities)) {
        hasWarning = true;
      }
      if (tab.tabIndex === 4 && !_size(formValues.actions)) {
        hasWarning = true;
      }
      return {
        ...tab,
        hasWarning,
      };
    });
  };

  handleContainerRef = ref => {
    this.containerRef = ref;
    this.zenScroller = zenscroll.createScroller(ref, 700, 0);
  };

  handleScrollBottom = () => {
    this.zenScroller.toY(this.containerRef.scrollHeight);
  };

  handleTabChange = tab => {
    this.setState({
      tab,
    });
  };

  handleSubmit = async values => {
    if (this.state.isContextCreateInjected) {
      return this.handleSubmitContext(values);
    }

    const { rule_group } = this.props.rule;
    const requestPayload = createRequestPayload(values);

    const { id, groupId } = await this.props.onUpdateRule(
      this.props.rule.id,
      requestPayload,
      '',
      rule_group,
    );

    // FIXME: We should check if error exist here and return. But error is not cleared
    //  correctly on redux. Bellow id is undefined if there is an error
    /* eslint-disable-next-line consistent-return */
    if (groupId === undefined) return;

    if (id !== this.props.rule.id || groupId !== rule_group) {
      this.props.history.replace(
        `${this.props.match.url}/${groupId}/rules/${id}`,
      );
    }

    return null;
  };

  handleOpenEntityModal = field => {
    this.setState({
      inspectInjectedFor: field,
      isCreateEntityModalOpen: true,
    });
  };

  handleCloseEntityModal = () => {
    this.setState({
      isCreateEntityModalOpen: false,
    });
  };

  handleInjectEntityInspect = () => {
    this.setState({
      isEntityInspectInjected: true,
    });
  };

  handleEjectEntityInspect = () => {
    this.setState({
      isEntityInspectInjected: false,
    });
  };

  handleInjectContextCreate = () => {
    this.setState({
      isContextCreateInjected: true,
    });
  };

  handleEjectContextCreate = () => {
    this.setState({
      isContextCreateInjected: false,
    });
  };

  handleCreateEntity = async ({ entityName }) => {
    await this.props.onAddEntity({
      name: entityName,
    });

    this.handleCloseEntityModal();
    this.handleInjectEntityInspect();
  };

  handleSaveAndRun = async event => {
    event.preventDefault();

    await this.props.dispatch(this.props.handleSubmit(this.handleSubmit));
    this.props.executeAnnotator();
  };

  handleSubmitContext = async values => {
    await this.props.onAddContext({
      name: values['create-new-context'],
      blocks: BLOCKS,
      isNew: false,
    });

    this.handleEjectContextCreate();
    this.props.change('context', this.props.context);
  };

  handleSubmitEntity = async () => {
    const { inspectInjectedFor } = this.state;
    const { entity, entityFormValues } = this.props;
    const { features, ...formValue } = entityFormValues;

    await this.props.onUpdateEntity(entity.id, formValue);

    if (!entity.xpack_resource) {
      await this.props.onUpdateEntityFeatures(
        entity.id,
        constructFeaturesToSave(features),
      );
    }

    this.props.change(`${inspectInjectedFor}.entity`, entity);
    this.props.change(
      `${inspectInjectedFor}.feature_values`,
      this.props.entityFeatures.map(feature => ({
        feature,
        value_type: '',
        dynamic_value: null,
        explicit_value: null,
        concatenation_value: null,
      })),
    );
    this.handleEjectEntityInspect();
  };

  handleDeleteRule = () => {
    this.props.onDeleteRule(this.props.rule.id, this.props.rule.rule_group);
    this.props.onClose();
  };

  handleMatchingPatternDelete = idToRemove => {
    let actionsShiftIndex = 0;
    this.props.formValues.actions.forEach((action, index) => {
      if (
        action.action_type === ACTION_TYPE.MARK ||
        action.action_type === ACTION_TYPE.UNMARK ||
        action.action_type === ACTION_TYPE.SHIFT ||
        action.action_type === ACTION_TYPE.FILL
      ) {
        const id = _get(
          action,
          `${action.action_type}.matching_pattern_element.id`,
          null,
        );

        const toId = _get(
          action,
          `${action.action_type}.matching_pattern_element_to.id`,
          null,
        );

        const fromId = _get(
          action,
          `${action.action_type}.matching_pattern_element_from.id`,
          null,
        );

        if (
          (id && id === idToRemove) ||
          (toId && toId === idToRemove) ||
          (fromId && fromId === idToRemove)
        ) {
          this.props.dispatch(
            arrayRemove(
              FORM_NAMES.RULES.INSPECT,
              'actions',
              index - actionsShiftIndex,
            ),
          );

          actionsShiftIndex += 1;
        }
      }

      if (
        action.action_type === ACTION_TYPE.MARK ||
        action.action_type === ACTION_TYPE.FILL
      ) {
        const actionType = action[action.action_type];

        if (actionType && actionType.feature_values) {
          actionType.feature_values.forEach((featureValue, featureIndex) => {
            if (featureValue.value_type === FEATURE_VALUE_TYPE.DYNAMIC) {
              const id = _get(
                featureValue,
                'dynamic_value.source_matching_pattern_element.id',
                null,
              );

              if (id && id === idToRemove) {
                const field = `actions[${index}].${action.action_type}.feature_values[${featureIndex}].dynamic_value`;

                this.props.change(
                  `${field}.source_matching_pattern_element`,
                  null,
                );

                this.props.change(`${field}.source_entity_feature`, null);
              }
            }

            if (featureValue.value_type === FEATURE_VALUE_TYPE.CONCATENATION) {
              featureValue.concatenation_value.forEach(
                (concatenationValue, concatenationIndex) => {
                  const id = _get(
                    featureValue,
                    `concatenation_value[${concatenationIndex}].source_matching_pattern_element.id`,
                    null,
                  );
                  if (id && id === idToRemove) {
                    const field = `actions[${index}].${action.action_type}.feature_values[${featureIndex}].concatenation_value[${concatenationIndex}]`;

                    this.props.change(
                      `${field}.source_matching_pattern_element`,
                      null,
                    );
                    this.props.change(`${field}.source_entity_feature`, null);
                  }
                },
              );
            }
          });
        }
      }
    });

    let conditionsShiftIndex = 0;
    this.props.formValues.conditions.forEach((action, index) => {
      const id = _get(
        action,
        `${action.condition_type}.matching_pattern_element.id`,
        null,
      );

      if (id && id === idToRemove) {
        this.props.dispatch(
          arrayRemove(
            FORM_NAMES.RULES.INSPECT,
            'conditions',
            index - conditionsShiftIndex,
          ),
        );

        conditionsShiftIndex += 1;
      }
    });
  };

  handleSearchEntity = (term = '', stock = true) => {
    this.props.onGetAllEntities({
      name__icontains: term,
      stock,
      size: 50,
    });
  };

  handleSearchContext = (term = '') => {
    this.props.onGetAllContexts({
      name__icontains: term,
      size: 50,
    });
  };

  handleSave = () =>
    this.props.dispatch(this.props.handleSubmit(this.handleSubmit));

  handleClose = () => {
    if (this.props.dirty) {
      this.handleOpenUnsavedChangesModal();
      return;
    }

    this.props.onClose();
  };

  handleForceCloseInspectorTab = () => {
    this.handleCloseUnsavedChangesModal();
    this.props.onClose(true);
  };

  handleOpenUnsavedChangesModal = () => {
    this.setState({
      isUnsavedChangesModalOpen: true,
    });
  };

  handleCloseUnsavedChangesModal = () => {
    this.props.onCloseUnsavedChangesModal();
    this.setState({
      isUnsavedChangesModalOpen: false,
    });
  };

  handleSaveUnsavedChanges = async () => {
    await this.handleSave();
    this.props.onClose();
  };

  handleDiscardUnsavedChanges = () =>
    this.props.selectedRule
      ? this.props.onChangeRule()
      : this.handleForceCloseInspectorTab();

  handlePartialExport = () => {
    this.props.partialExport(`rule-${this.props.rule.name}`, [
      this.props.ruleId,
    ]);
  };

  renderModals = () => {
    const { onCheckEntityName, showUnsavedChangesModal } = this.props;
    const { isUnsavedChangesModalOpen, isCreateEntityModalOpen } = this.state;

    return (
      <React.Fragment>
        {(isUnsavedChangesModalOpen || showUnsavedChangesModal) && (
          <UnsavedChangesModal
            isOpen
            onCancel={this.handleCloseUnsavedChangesModal}
            onDiscard={this.handleDiscardUnsavedChanges}
          />
        )}

        {isCreateEntityModalOpen && (
          <CreateNewEntityModal
            onCheckEntityName={onCheckEntityName}
            onClose={this.handleCloseEntityModal}
            onSubmit={this.handleCreateEntity}
          />
        )}
      </React.Fragment>
    );
  };

  renderTab = () => {
    const { tab, isContextCreateInjected } = this.state;

    const {
      rule,
      change,
      untouch,
      entities,
      features,
      contexts,
      formValues,
      orderList,
      ruleGroups,
      ruleGroupsIsLoading,
      entitiesIsLoading,
      contextsIsLoading,
      hasMandatoryMPE,
      onGetAllRuleGroups,
      matchingPatterns,
      matchingPatternsWithoutAny,
      matchingPatternsWithoutAnyAndW,
    } = this.props;

    if (tab === TABS[0].tabIndex) {
      return (
        <GeneralTab
          allRuleGroups={ruleGroups}
          change={change}
          formValues={formValues}
          isArchived={rule.archived}
          isLoading={ruleGroupsIsLoading}
          rootOrderList={orderList}
          onDeleteRule={this.handleDeleteRule}
          onGetAllRuleGroups={onGetAllRuleGroups}
        />
      );
    }
    if (tab === TABS[1].tabIndex) {
      return (
        <MatchingPatternTab
          allEntities={entities}
          change={change}
          hasMandatory={hasMandatoryMPE}
          isArchived={rule.archived}
          isLoading={entitiesIsLoading}
          onDelete={this.handleMatchingPatternDelete}
          onSearchEntity={this.handleSearchEntity}
        />
      );
    }

    if (tab === TABS[2].tabIndex) {
      return (
        <ConditionsTab
          allEntities={entities}
          allFeatures={features}
          change={change}
          filteredMatchingPatterns={matchingPatternsWithoutAnyAndW}
          innerRef={this.handleContainerRef}
          isArchived={rule.archived}
          isLoading={entitiesIsLoading}
          matchingPatterns={matchingPatternsWithoutAny}
          onScrollBottom={this.handleScrollBottom}
          onSearchEntity={this.handleSearchEntity}
        />
      );
    }

    if (tab === TABS[3].tabIndex) {
      return (
        <ActionsTab
          allEntities={entities}
          allFeatures={features}
          change={change}
          innerRef={this.handleContainerRef}
          isArchived={rule.archived}
          isLoading={entitiesIsLoading}
          matchingPatterns={matchingPatterns}
          matchingPatternsWithoutAnyAndW={matchingPatternsWithoutAnyAndW}
          untouch={untouch}
          values={formValues.actions}
          onCreateEntity={this.handleOpenEntityModal}
          onScrollBottom={this.handleScrollBottom}
          onSearchEntity={this.handleSearchEntity}
        />
      );
    }

    if (tab === TABS[4].tabIndex) {
      if (isContextCreateInjected) {
        return <ContextCreate />;
      }

      return (
        <ContextTab
          allContexts={contexts}
          context={formValues.context}
          isArchived={rule.archived}
          isLoading={contextsIsLoading}
          onCreateContext={this.handleInjectContextCreate}
          onSearchContext={this.handleSearchContext}
        />
      );
    }

    return null;
  };

  render() {
    const {
      tab,
      isContextCreateInjected,
      isEntityInspectInjected,
    } = this.state;

    const {
      rule,
      dirty,
      entity,
      invalid,
      invalidWithUnregistered,
      asyncValidating,
      isLoading,
      hasMandatoryMPE,
      handleSubmit,
      hasSelectedTestSet,
      testSetEntriesCount,
    } = this.props;

    const tabs = this.getTabs();
    const disabled =
      !dirty ||
      invalidWithUnregistered ||
      invalid ||
      !hasMandatoryMPE ||
      !!asyncValidating;

    return (
      <HotKeys
        handlers={this.keyHandlers}
        keyMap={HOTKEYS_MAP}
        styleName="root"
      >
        {this.renderModals()}

        <InspectLoader isLoading={isLoading} />

        <Headers
          changeTab={this.handleTabChange}
          closeTabs={this.handleClose}
          icon="icon-context-rules"
          rule={rule}
          selectedTabIndex={tab}
          tabs={tabs}
        />

        {/* EntityInspect can not be inside the form as it form by itsown */}
        {tab === TABS[3].tabIndex && isEntityInspectInjected && (
          <EntityInspect
            dirtyOnInit
            closeTabs={this.handleEjectEntityInspect}
            currentEntity={entity}
            id={entity.id}
            isArchived={rule.archived}
            selectedTabIndex={1}
            showTabs={false}
            onSubmit={this.handleSubmitEntity}
          />
        )}

        <Form onSubmit={handleSubmit(this.handleSubmit)}>
          {this.renderTab()}

          {!isEntityInspectInjected && (
            <InspectFooter>
              {!rule.archived && (
                <React.Fragment>
                  <InspectButton
                    isFooter
                    data-test="export-entity-button"
                    onClick={this.handlePartialExport}
                  >
                    Export
                  </InspectButton>

                  {hasSelectedTestSet && testSetEntriesCount > 0 && (
                    <InspectButton
                      isFooter
                      data-test="submit-and-run"
                      disabled={disabled}
                      onClick={this.handleSaveAndRun}
                    >
                      Save & Run
                    </InspectButton>
                  )}

                  <InspectButton
                    isFooter
                    isSave
                    data-test="submit"
                    disabled={disabled}
                    type="submit"
                  >
                    Save
                  </InspectButton>

                  {isContextCreateInjected && (
                    <InspectButton
                      isFooter
                      isSave
                      data-test="cancel"
                      onClick={this.handleEjectContextCreate}
                    >
                      Cancel
                    </InspectButton>
                  )}
                </React.Fragment>
              )}
            </InspectFooter>
          )}
        </Form>
      </HotKeys>
    );
  }
}

const mapStateToProps = state => {
  const rule = rulesSelectors.getRule(state);
  const ruleEntities = ruleEntitiesSelectors.getRuleEntitiesList(state);
  const ruleHasGroup = !_isEmpty(rule.groupDetails);

  const entities = entitiesSelectors.getAllEntities(state);
  const contexts = contextSelectors.getContextsAll(state);
  const ruleGroups = ruleGroupsSelectors.getRuleGroupsAll(state);

  const order =
    // eslint-disable-next-line no-nested-ternary
    ruleHasGroup && rule.groupDetails.visible
      ? `${rule.groupDetails.order + 1}.${rule.order + 1}`
      : ruleHasGroup
      ? rule.groupDetails.order + 1
      : 1;

  return {
    rule,
    entity: entitiesSelectors.getEntity(state),
    entityFeatures: entitiesFeaturesSelectors.getEntitiesFeaturesList(state),
    context: contextSelectors.getContext(state),
    entities,
    contexts,
    features: featuresSelectors.getFeatures(state),
    ruleGroups,
    orderList: ruleGroupsSelectors.getRuleGroupsOrderList(state),
    ruleGroupsIsLoading: ruleGroupsSelectors.getIsLoadingAll(state),
    entitiesIsLoading: entitiesSelectors.getIsLoadingAll(state),
    contextsIsLoading: contextSelectors.getIsLoadingAll(state),

    isLoading:
      rulesSelectors.getIsRuleLoading(state) ||
      rulesSelectors.getIsUpdating(state) ||
      rulesSelectors.getIsPartialUpdating(state) ||
      ruleGroupsSelectors.getIsGroupPartialUpdating(state) ||
      ruleEntitiesSelectors.getEntitiesIsListLoading(state),

    // TEST-SETS:
    hasSelectedTestSet: testSetsSelectors.getHasSelectedTestSet(state),
    testSetEntriesCount: testSetEntriesSelectors.getTestSetEntriesListCount(
      state,
    ),

    // MATCHING-PATTERNS:
    hasMandatoryMPE: rulesSelectors.hasMandatoryMPE(state),
    matchingPatterns: rulesSelectors.getMatchingPatternEntities(state),
    matchingPatternsWithoutAny: rulesSelectors.getFilteredConditionsEntities(
      state,
    ),
    matchingPatternsWithoutAnyAndW: rulesSelectors.getFilteredEntities(state),

    // FORM:
    entityFormValues: getFormValues(FORM_NAMES.ENTITIES.INSPECT)(state),
    formValues: getFormValues(FORM_NAMES.RULES.INSPECT)(state),

    // REDUX-FORM:
    // TODO: Try to find the wat how to check if all fields across the tabs are valid
    invalidWithUnregistered: !_isEmpty(
      getFormSyncErrors(FORM_NAMES.RULES.INSPECT)(state),
    ),
    initialValues: {
      ...createReduxFormInitialValues(rule, ruleEntities),
      order,
      context: rule.contextDetails,
      group:
        ruleHasGroup && rule.groupDetails.visible ? rule.groupDetails : null,
    },
  };
};

const mapDispatchToProps = {
  partialExport: rulesActions.partialExportSingleRule,
  // RULE:
  onUpdateRule: rulesActions.updateRule,
  onDeleteRule: rulesActions.deleteRule,

  // CONTEXTS:
  onAddContext: contextActions.addContext,
  onGetAllContexts: contextActions.getContextsAll,
  onCheckContextName: contextActions.checkContextName,

  // ENTITIES:
  onAddEntity: entitiesActions.addEntity,
  onUpdateEntity: entitiesActions.updateEntity,
  onUpdateEntityFeatures: entitiesFeaturesActions.multiEntitiesFeature,
  onCheckEntityName: entitiesActions.checkEntityName,
  onGetAllEntities: entitiesActions.getAllEntities,

  // RULE GROUPS:
  onGetAllRuleGroups: ruleGroupsActions.getAllRuleGroups,
};

const asyncValidate = async (formProps, dispatch, props) => {
  if (formProps['create-new-context']) {
    await props.onCheckContextName(
      'create-new-context',
      formProps['create-new-context'],
    );
  }
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(
    reduxForm({
      validate,
      asyncValidate,
      asyncChangeFields: ['create-new-context'],
      form: FORM_NAMES.RULES.INSPECT,
      touchOnBlur: true,
      touchOnChange: true,
      destroyOnUnmount: false,
    })(Inspect),
  ),
);
